import React, { Fragment } from "react";

import { PropertyDetails } from "../shared-components/ViewFragments/PropertyDetails/web";
import { PropertyDetailsPrint } from "../shared-components/ViewFragments/PropertyDetailsPrint/web";
import { RTBhouse } from "../shared-components/Components/RTBhouse/web";
import { decodeHashUrl } from "../shared-components/Utils/Functions";
import { useRouter } from "next/router";
import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../shared-components/i18n";

// PropSingle
const propSingle = props => {
	const { asPath } = useRouter();
	const isPrint = asPath.includes("imprimir");

	return (
		<Fragment>
			{isPrint ? (
				<PropertyDetailsPrint id={props.__PROPERTY__ID__} mode="property" />
			) : (
				<PropertyDetails id={props.__PROPERTY__ID__} mode="property" />
			)}
			<RTBhouse page={"offer"} data={props.__PROPERTY__ID__} />
		</Fragment>
	);
};

propSingle.getInitialProps = async function({ apolloClient, req, res, query }) {
	let property = await decodeHashUrl(query.hashed);
	const __PROPERTY__ID__ = property.id;
	return {
		__PROPERTY__ID__,
		UrlToBack: query.location || -1,
		DummyContextInitialState: { count: 23 },
		ConfigContextInitialState: property?.configs,
	};
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(propSingle))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);
